import type { BuildingQuery, UnitQuery } from "../api/client";

export type View = "buildings" | "units";

export interface Filters {
  search: string;
  milestone_only: boolean;
  unsafe_only: boolean;
  min_rate: number;
  min_score: number;
  order: string;
  flag: string;
  /**
   * Five-digit county FIPS, or "" for every county we hold. This one is not
   * really a filter — it comes from the URL and the coverage map, and the
   * backend keeps it even for tiers that have no filtering at all.
   */
  county: string;
}

export const EMPTY_FILTERS: Filters = {
  search: "",
  milestone_only: false,
  unsafe_only: false,
  min_rate: 0,
  min_score: 0,
  order: "score",
  flag: "",
  county: "",
};

export const PAGE_SIZE = 200;

/**
 * The two views share one filter object because the search box and score
 * threshold apply to both. These pick out the subset each endpoint accepts —
 * sending `flag` to /api/buildings would just be noise in the logs.
 */
export function toBuildingQuery(filters: Filters): BuildingQuery {
  return {
    limit: PAGE_SIZE,
    milestone_only: filters.milestone_only,
    unsafe_only: filters.unsafe_only,
    min_score: filters.min_score,
    min_rate: filters.min_rate,
    search: filters.search.trim(),
    order: filters.order,
    county: filters.county,
  };
}

export function toUnitQuery(filters: Filters): UnitQuery {
  return {
    limit: PAGE_SIZE,
    min_score: filters.min_score,
    flag: filters.flag,
    search: filters.search.trim(),
    county: filters.county,
  };
}
